// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import RewardTypeSection from "@rc/App/Components/RewardsTypes/RewardTypeSection";
import * as React from "react";

interface RewardTypes {
    discountName: string;
    discountAmount: number;
}

export interface RewardsTypesCardProps {
    title: React.ReactNode;
    rewardTypes: RewardTypes[] | undefined;
    rewardNoteMessage?: React.ReactNode;
}
type Props = RewardsTypesCardProps;

interface RewardsTypesCardStyles {
    cardContainer?: InjectableCss;
    title?: TypographyPresentationProps;
    rewardNoteMessage?: TypographyPresentationProps;
    noRewards?: TypographyPresentationProps;
}

export const rewardsTypesCardStyles: RewardsTypesCardStyles = {};

const styles = rewardsTypesCardStyles;

const RewardsTypesCard: React.FC<Props> = ({ title, rewardTypes, rewardNoteMessage }) => {
    const getZerosValues = React.useMemo(() => {
        return rewardTypes?.every(reward => !Number(reward.discountAmount));
    }, [rewardTypes]);

    return (
        <StyledWrapper {...styles.cardContainer}>
            <Typography {...styles.title}>{title}</Typography>
            {rewardTypes && !getZerosValues ? (
                <>
                    {rewardTypes.map((rewardType, index) => (
                        <RewardTypeSection
                            key={index}
                            title={rewardType.discountName}
                            value={rewardType.discountAmount}
                        />
                    ))}
                    {rewardNoteMessage && <Typography {...styles.rewardNoteMessage}>{rewardNoteMessage}</Typography>}
                </>
            ) : (
                <Typography {...styles.noRewards}>{translate("No Rewards")}</Typography>
            )}
        </StyledWrapper>
    );
};

export default RewardsTypesCard;
